export default "__VITE_ASSET__8ade8e68__"